import { render, staticRenderFns } from "./AProgramasAsignacion.vue?vue&type=template&id=637b7143"
import script from "./AProgramasAsignacion.vue?vue&type=script&lang=js"
export * from "./AProgramasAsignacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports